import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import { Field, reduxForm, Form } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import {
  isRequired,
} from '../../../../utils/validators';
import TextInput from '../../../common/forms/input/TextInput';
import { SECURITY_VISIBILITY } from '../../../../config/constants';
import Select from '../../../common/forms/select/Select';
import FormFooter from '../../../common/forms/FormFooter';
import { enumToSelectOptions } from '../../../../utils/enum';
import { connect } from 'react-redux';
import ViewSelect from '../../../common/forms/select/ViewSelect';
import EndpointSelect from '../../../common/forms/select/EndpointSelect';

const SecurityProfileForm = ({ 
  initialValues, 
  handleSubmit,
}) => {

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre" required>
          <Field
            name="name"
            component={TextInput}
            placeholder="Nombre"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descripción">
          <Field
            name="description"
            component={TextInput}
            type="textarea"
            placeholder="Descripción"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Vistas Autorizadas">
          <Field name="viewAuthorizationList" component={ViewSelect} isMulti />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Puntos de Acceso Autorizados">
          <Field name="authorizedEndpointList" component={EndpointSelect} isMulti />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Visibilidad">
          <Field
            name="securityVisibility"
            component={Select}
            isClearable={false}
            options={enumToSelectOptions(SECURITY_VISIBILITY)}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );
};

SecurityProfileForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

SecurityProfileForm.defaultProps = {
  initialValues: null,
};

const formComponent = reduxForm({
  form: 'SecurityProfileForm',
})(SecurityProfileForm);

export default connect()(formComponent);
